/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "TransformType": () => (/* reexport */ TransformType),
  "createPixboostParams": () => (/* reexport */ createPixboostParams),
  "getPixboostImageUrl": () => (/* reexport */ getPixboostImageUrl),
  "getPixboostSizes": () => (/* reexport */ getPixboostSizes),
  "getSrc": () => (/* reexport */ getSrc),
  "getSrcSet": () => (/* reexport */ getSrcSet),
  "resizes": () => (/* reexport */ resizes)
});

;// CONCATENATED MODULE: ./cdnImage.types.ts
var TransformType;
(function(TransformType) {
    TransformType["SQUARE"] = 'square';
    TransformType["LOGO"] = 'logo';
    TransformType["BANNER"] = 'banner';
    TransformType["MOBILE_BANNER"] = 'mobile_banner';
    TransformType["OG"] = 'og';
    TransformType["POPUP_NOTIFICATION"] = 'popup_notification';
    TransformType["LANDSCAPE"] = 'landscape';
    TransformType["LOYALTY_HEADER"] = 'loyalty_header';
    TransformType["VLP"] = 'vlp';
    TransformType["DEFAULT"] = 'default';
    TransformType["AVATAR"] = 'avatar';
})(TransformType || (TransformType = {}));
const resizes = {
    square: [
        {
            width: 1200,
            height: 1200
        },
        {
            width: 800,
            height: 800
        },
        {
            width: 500,
            height: 500
        },
        {
            width: 300,
            height: 300
        },
        {
            width: 100,
            height: 100
        }
    ],
    logo: [
        {
            width: 976
        },
        {
            width: 488
        },
        {
            width: 244
        },
        {
            width: 122
        },
        {
            width: 125
        }
    ],
    banner: [
        {
            width: 1080,
            height: 1920
        },
        {
            width: 540,
            height: 960
        },
        {
            width: 270,
            height: 480
        },
        {
            width: 135,
            height: 240
        },
        {
            width: 68,
            height: 120
        }
    ],
    mobile_banner: [
        {
            width: 1170,
            height: 409
        },
        {
            width: 540,
            height: 189
        },
        {
            width: 270,
            height: 94
        }
    ],
    og: [
        {
            width: 1200,
            height: 627
        }
    ],
    popup_notification: [
        {
            width: 1000,
            height: 500
        },
        {
            width: 500,
            height: 250
        },
        {
            width: 380,
            height: 190
        }
    ],
    landscape: [
        {
            width: 1000,
            height: 400
        },
        {
            width: 500,
            height: 200
        },
        {
            width: 250,
            height: 100
        }
    ],
    loyalty_header: [
        {
            width: 1080,
            height: 1920
        },
        {
            width: 540,
            height: 960
        },
        {
            width: 270,
            height: 480
        },
        {
            width: 135,
            height: 240
        }
    ],
    vlp: [
        {
            width: 1074,
            height: 372
        },
        {
            width: 716,
            height: 248
        },
        {
            width: 358,
            height: 124
        }
    ],
    default: [
        {
            width: 1000
        }
    ],
    avatar: [
        {
            width: 200
        },
        {
            width: 100
        }
    ]
};

;// CONCATENATED MODULE: ./cdnImage.utils.ts

const getPixboostImageUrl = ({ pixboostUrl , originalImagePath  })=>{
    let newPath = originalImagePath;
    const splitPath = newPath.split('/');
    const region = splitPath[0].split('-');
    if (region[1]) {
        newPath = region[1] + region[0] + '/' + splitPath.slice(1).join('/');
    }
    return `${pixboostUrl}/${newPath}`;
};
const createPixboostParams = ({ pixboostAuth , pixboostImageUrl , size  })=>{
    const dimensions = size.height ? `${size.width}x${size.height}` : size.width.toString();
    const arg = size.height ? 'fit' : 'resize';
    return `${pixboostImageUrl}/${arg}?size=${dimensions}&auth=${pixboostAuth}`;
};
const getSrc = ({ pixboostUrl , pixboostAuth , originalImageUrl , originalImagePath , transform  })=>{
    const sizes = resizes[transform || TransformType.DEFAULT];
    if (!originalImagePath) {
        return originalImageUrl;
    }
    const pixboostImageUrl = getPixboostImageUrl({
        pixboostUrl,
        originalImagePath
    });
    if (sizes) {
        return createPixboostParams({
            pixboostImageUrl,
            size: sizes[0],
            pixboostAuth
        });
    }
    return createPixboostParams({
        pixboostImageUrl,
        size: {
            width: 1000
        },
        pixboostAuth
    });
};
const getSrcSet = ({ pixboostUrl , pixboostAuth , originalImagePath , transform  })=>{
    const sizes = resizes[transform || TransformType.DEFAULT];
    if (!sizes || !originalImagePath) {
        return '';
    }
    const pixboostImageUrl = getPixboostImageUrl({
        originalImagePath,
        pixboostUrl
    });
    return sizes.map((size)=>{
        return `${createPixboostParams({
            pixboostImageUrl,
            size,
            pixboostAuth
        })} ${size.width}w`;
    }).join(', ');
};
const getPixboostSizes = ({ pixboostUrl , pixboostAuth , originalImagePath , transform  })=>{
    const sizes = resizes[transform || TransformType.DEFAULT];
    if (!sizes || !originalImagePath) {
        return [];
    }
    const pixboostImageUrl = getPixboostImageUrl({
        pixboostUrl,
        originalImagePath
    });
    return sizes.map((size)=>createPixboostParams({
            pixboostAuth,
            pixboostImageUrl,
            size
        }));
};

;// CONCATENATED MODULE: ./index.ts



var __webpack_export_target__ = exports;
for(var i in __webpack_exports__) __webpack_export_target__[i] = __webpack_exports__[i];
if(__webpack_exports__.__esModule) Object.defineProperty(__webpack_export_target__, "__esModule", { value: true });
/******/ })()
;
//# sourceMappingURL=index.js.map